// extracted by mini-css-extract-plugin
var _1 = "baseHomeSection-module__baseHomeSection___Zzexa";
export { _1 as "baseHomeSection" }
